// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::calendarDateConverter_parseError:::Try again using a complete date like this: ' +
    p['dateExample'] +
    '.]]',
  chart_labelGroup: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::chart_labelGroup:::Group]]',
  chart_labelSeries: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::chart_labelSeries:::Series]]',
  chart_labelValue: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::chart_labelValue:::Value]]',
  checkboxSet_requiredMessageDetail: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::checkboxSet_requiredMessageDetail:::Required]]',
  checkbox_requiredMessageDetail: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::checkbox_requiredMessageDetail:::Required]]',
  close: () => '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::close:::Close]]',
  collection_noData: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::collection_noData:::No data to display.]]',
  collection_selectAllRows: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::collection_selectAllRows:::Select all rows]]',
  collection_selectRow: (p: { ROW_NAME: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::collection_selectRow:::Select row ' +
    p['ROW_NAME'] +
    ']]',
  collection_sortDisabled: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::collection_sortDisabled:::Not sortable]]',
  collection_sortEnabled: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::collection_sortEnabled:::Sortable]]',
  confirmation: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::confirmation:::Confirmation]]',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::dataVisualization_labelCountWithTotal:::' +
    p['itemCount'] +
    ' out of ' +
    p['totalCount'] +
    ']]',
  dataVisualization_noData: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::dataVisualization_noData:::No data to display]]',
  dataVisualization_stateSelected: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::dataVisualization_stateSelected:::Selected]]',
  dataVisualization_stateUnselected: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::dataVisualization_stateUnselected:::Unselected]]',
  error: () => '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::error:::Error]]',
  expandableList_expandCollapseInstructionText: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::expandableList_expandCollapseInstructionText:::Use arrow keys to expand and collapse]]',
  expandableList_groupCollapse: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::expandableList_groupCollapse:::Collapsed]]',
  expandableList_groupExpand: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::expandableList_groupExpand:::Expanded]]',
  filePicker_addFiles: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::filePicker_addFiles:::Add Files]]',
  filePicker_dropzonePrimaryText: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::filePicker_dropzonePrimaryText:::Drag and Drop]]',
  filePicker_dropzoneSecondaryText: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::filePicker_dropzoneSecondaryText:::Select a file or drop one here]]',
  filePicker_dropzoneSecondaryTextMultiple: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::filePicker_dropzoneSecondaryTextMultiple:::Select or drop files here]]',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    "[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::filePicker_multipleFileTypeUploadError:::You can't upload files of type: " +
    p['fileTypes'] +
    ']]',
  filePicker_singleFileUploadError: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::filePicker_singleFileUploadError:::Upload one file at a time]]',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    "[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::filePicker_singleTypeUploadError:::You can't upload files of type " +
    p['fileType'] +
    ']]',
  filePicker_unknownFileTypeUploadError: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::filePicker_unknownFileTypeUploadError:::unknown]]',
  formControl_clear: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_clear:::Clear]]',
  formControl_day: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_day:::Day]]',
  formControl_helpAvailable: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_helpAvailable:::Help available]]',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_limitReached:::You’ve reached the limit of ' +
    (({ one: '1 character' } as Partial<Record<Intl.LDMLPluralRule, string>>)[
      new Intl.PluralRules('en-XC').select(p['CHARACTER_LIMIT'])
    ] || new Intl.NumberFormat('en-XC').format(p['CHARACTER_LIMIT']) + ' characters') +
    '.]]',
  formControl_loading: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_loading:::Loading]]',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_maxLengthExceeded:::Maximum length ' +
    p['MAX_LENGTH'] +
    ' exceeded.]]',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_maxLengthRemaining:::' +
    p['CHARACTER_COUNT'] +
    ' characters left.]]',
  formControl_month: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_month:::Month]]',
  formControl_readOnly: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_readOnly:::Read only]]',
  formControl_requiredMessageDetail: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_requiredMessageDetail:::Enter a value.]]',
  formControl_year: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_year:::Year]]',
  gantt_labelDate: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::gantt_labelDate:::Date]]',
  gantt_labelEnd: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::gantt_labelEnd:::End]]',
  gantt_labelLabel: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::gantt_labelLabel:::Label]]',
  gantt_labelRow: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::gantt_labelRow:::Row]]',
  gantt_labelStart: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::gantt_labelStart:::Start]]',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::indexer_disabledLabel:::' +
    p['SECTION'] +
    '. No matching section found.]]',
  indexer_keyboardInstructionText: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::indexer_keyboardInstructionText:::Press enter to select value.]]',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::indexer_separatorLabel:::Between ' +
    p['FROM_SECTION'] +
    ' and ' +
    p['TO_SECTION'] +
    '.]]',
  indexer_touchInstructionText: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::indexer_touchInstructionText:::Double tap and hold to enter gesture mode, then drag up or down to adjust value.]]',
  info: () => '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::info:::Info]]',
  inputDateMask_date_cleared: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputDateMask_date_cleared:::Date cleared]]',
  inputDateMask_dayPlaceholder: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputDateMask_dayPlaceholder:::dd]]',
  inputDateMask_empty_segment: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputDateMask_empty_segment:::Empty]]',
  inputDateMask_monthPlaceholder: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputDateMask_monthPlaceholder:::mm]]',
  inputDateMask_yearPlaceholder: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputDateMask_yearPlaceholder:::yyyy]]',
  inputNumber_converterParseError: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputNumber_converterParseError:::Enter a number.]]',
  inputNumber_decrease: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputNumber_decrease:::Decrease]]',
  inputNumber_increase: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputNumber_increase:::Increase]]',
  inputPassword_hidden: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputPassword_hidden:::Password Hidden]]',
  inputPassword_hide: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputPassword_hide:::Hide Password]]',
  inputPassword_show: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputPassword_show:::Show Password]]',
  list_suggestion: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::list_suggestion:::Suggestion]]',
  messageToast_allMessagesClosed: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::messageToast_allMessagesClosed:::All toast messages are closed.]]',
  message_close: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::message_close:::Close]]',
  message_confirmation: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::message_confirmation:::Success]]',
  message_error: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::message_error:::Error]]',
  message_info: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::message_info:::Info]]',
  message_navigationFromMessagesRegion: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::message_navigationFromMessagesRegion:::Entering messages region. Press F6 to navigate back to prior focused element.]]',
  message_navigationToMessagesRegion: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::message_navigationToMessagesRegion:::Messages region has new messages. Press F6 to navigate to the most recent message region.]]',
  message_warning: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::message_warning:::Warning]]',
  noData_message: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::noData_message:::No items to display]]',
  overflowItemLabel: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::overflowItemLabel:::More Tabs]]',
  plural_separator: () => ', ',
  progressIndeterminate: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::progressIndeterminate:::In Progress]]',
  radio_helpForRadio: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::radio_helpForRadio:::Help for radio button]]',
  radio_requiredMessageDetail: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::radio_requiredMessageDetail:::Select a value.]]',
  selectMultiple_apply: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selectMultiple_apply:::Apply]]',
  selectMultiple_back: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selectMultiple_back:::Back]]',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selectMultiple_removeSelectedTagInstructionText:::Press Backspace or Delete to remove the selected value.]]',
  selectMultiple_selectedValues: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selectMultiple_selectedValues:::Selected values]]',
  selectMultiple_showSelectedValues: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selectMultiple_showSelectedValues:::Show selected values only.]]',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selectMultiple_valuesSelected:::' +
    p['VALUE_COUNT'] +
    ' values selected.]]',
  select_addToList: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::select_addToList:::Add to list]]',
  select_addToListAvailable: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::select_addToListAvailable:::Add to list available]]',
  select_moreSearchOptions: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::select_moreSearchOptions:::More search options]]',
  select_moreSearchOptionsAvailable: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::select_moreSearchOptionsAvailable:::More search options available]]',
  select_noMatchesFound: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::select_noMatchesFound:::No matches found.]]',
  select_oneMatchFound: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::select_oneMatchFound:::One match found]]',
  select_requiredMessageDetail: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::select_requiredMessageDetail:::Select a value.]]',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::select_sizeMatchesFound:::' +
    p['TOTAL_SIZE'] +
    ' matches found]]',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::select_sizeOrMoreMatchesFound:::' +
    p['TOTAL_SIZE'] +
    ' or more matches found]]',
  selector_selected: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selector_selected:::Checkbox checked]]',
  selector_unselected: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selector_unselected:::Checkbox not checked]]',
  tabBarNavigationList_removeCueText: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::tabBarNavigationList_removeCueText:::Removable]]',
  timeComponent_tooltipZoomIn: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::timeComponent_tooltipZoomIn:::Zoom In]]',
  timeComponent_tooltipZoomOut: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::timeComponent_tooltipZoomOut:::Zoom Out]]',
  train_current: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::train_current:::Current]]',
  train_message_type: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::train_message_type:::Message Type]]',
  train_not_visited: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::train_not_visited:::Not visited]]',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::train_status:::Step ' +
    p['currentStep'] +
    ' out of ' +
    p['numberOfSteps'] +
    ']]',
  train_visited: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::train_visited:::Visited]]',
  userAssistance_learnMore: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::userAssistance_learnMore:::Learn more]]',
  userAssistance_required: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::userAssistance_required:::Required]]',
  viz_drillable: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::viz_drillable:::Drillable]]',
  warn: () => '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::warn:::Warning]]'
};
export default bundle;
